import { HeroBackground, useWindowWidth } from '@prishapolicy/shared/ui';
import { ArticleJsonLd, NextSeo } from 'next-seo';
import React from 'react';
import styles from './blog.module.scss';
import fs from 'fs';
import { BLOG_WRITEUPS_PATH, Breadcrumbs, VerticalMdBreakBlogCard } from '@prishapolicy/w3/ui';
import { BlogArticleFrontMatter, getParsedFileContentBySlug } from '@prishapolicy/markdown';
import { twMerge } from 'tailwind-merge';

const AllArticles = (props: ReturnType<typeof getStaticProps>['props']) => {
  const { isLg } = useWindowWidth();

  return (
    <>
      <NextSeo
        title="All Articles | PrishaPolicy"
        description="PrishaPolicy blog provides valuable insights and tips on protecting yourself, your family, and your assets. Stay up-to-date on the latest industry news and learn about different types of insurance coverage options. From car insurance to life insurance and everything in between, we've got you covered."
      />
      <ArticleJsonLd
        authorName={'PrishaPolicy'}
        datePublished={props.latestArticle.date}
        description="From health insurance to motor insurance and everything in between, we've got you covered"
        images={[`/blog-assets/${props.latestArticle.slug}/cover.png`]}
        publisherLogo=""
        url={`https://prishapolicy.com/resources/blog/all-articles`}
        title="All Articles"
        type="Blog"
      />
      <div className="relative">
        <HeroBackground className={twMerge(`${styles.heroBackground} max-h-[400px]`)}>
          <div className="text-left">
            <h1
              className="mt-4 font-bold text-black "
              style={{
                fontSize: isLg ? 70 : 40,
                backgroundRepeat: 'repeat',
                backgroundPositionY: '13px',
              }}
            >
              All Articles
            </h1>
          </div>
        </HeroBackground>

        <div className="container pt-5 pb-10">
          <Breadcrumbs
            breadCrumbs={[
              {
                label: 'Home',
                href: '/resources/blog',
              },
              {
                label: 'All Articles',
              },
            ]}
          />
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
            {props.articlesData.map((blog, index) => (
              <>
                <VerticalMdBreakBlogCard blog={blog} key={index} />
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export const getStaticProps = () => {
  const blogsDir = fs.readdirSync(BLOG_WRITEUPS_PATH);
  const articlesData = blogsDir.map((blogFile) => {
    const blogSlug = blogFile.replace(/\.mdx?$/, '');
    const mdContent = getParsedFileContentBySlug<BlogArticleFrontMatter>(blogSlug, BLOG_WRITEUPS_PATH);

    return { ...mdContent.frontMatter, slug: blogSlug };
  });

  const latestArticle = articlesData.reduce((acc, curr) => {
    if (new Date(curr.date) > new Date(acc.date)) {
      acc = curr;
    }
    return acc;
  });

  return { props: { articlesData, latestArticle } };
};

export default AllArticles;
